import { Chip } from "@material-ui/core";
import axios from "axios"
import { useEffect } from "react";

const Genres = (
    {selectedGenres,
    setSelectedGenres,
    genres,
    setGenres,
    type,
    setPage,}) => {

        //Creating a function for the add event
        const handleAdd =(genre)=>{
            setSelectedGenres([...selectedGenres , genre]);
            setGenres(genres.filter((g) => g.id !== genre.id));
            setPage(1);
        }

        //Creating a function for the remove event
        const handleRemove =(genre)=>{
            setSelectedGenres(selectedGenres.filter((selected) => selected.id !== genre.id));

            setGenres([...genres , genre]);

            setPage(1); 
        }

        const fetchGenres = async () =>{
           const {data}= await axios.get(`
            https://api.themoviedb.org/3/genre/${type}/list?api_key=2c629ca30095712591ced9ffe3cd649c&language=en-US`)
        setGenres(data.genres)
        };

        console.log(genres);
        useEffect(() =>{
            fetchGenres()
             
            return () => {
                setGenres({})
            };
           },
          // eslint-disable-next-line
           []);
           
    return (
        <div style={{padding:'6px 0'}}>
         {selectedGenres && selectedGenres.map((genre) => (
         <Chip
            label = {genre.name}
            size='small'
            color='primary'
             style ={{margin:2}}
             key={genre.id} 
             clickable
             onDelete={() => handleRemove(genre)}
         />
     ))}

     {genres && genres.map((genre) => (
         <Chip label = {genre.name}
            size = 'small'
             style ={{margin:2}}
            key = {genre.id} 
             clickable
             onClick={()=>handleAdd(genre)}
         />
     ))}
      
        
        </div>
    )
}

export default Genres